/**
 * Internal dependencies
 */
import mediaUpload from './media-upload';

export { mediaUpload };
